import {createFileRoute} from '@tanstack/react-router';
import {isPaymentMode} from 'features/shared/payment/types/PaymentMode';
import {StatementPaymentOpenBankingCallbackPage} from 'features/statement-payment/pages/StatementPaymentOpenBankingCallbackPage';

export const Route = createFileRoute(
  '/_protected/statement-payment/$statementId/callback/open-banking',
)({
  component: StatementPaymentOpenBankingCallbackPage,
  validateSearch: (search) => {
    return {
      paymentId: `${search.paymentId}`,
      paymentMode: isPaymentMode(search.paymentMode)
        ? search.paymentMode
        : 'openbanking_sessionless',
    } as const;
  },
});
